interface ChipProps {
  label: string;
  onRemove?: () => void;
  size?: "sm" | "md";
}

function Chip({ label, onRemove, size = "sm" }: ChipProps) {
  const sizeClasses = size === "md" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span className={`inline-flex items-center gap-1 bg-gray-100 text-gray-700 rounded-full ${sizeClasses}`}>
      {label}
      {onRemove && (
        <button type="button" onClick={onRemove} className="text-gray-400 hover:text-gray-700 leading-none">
          ×
        </button>
      )}
    </span>
  );
}

export default Chip;
